// extracted by mini-css-extract-plugin
export default {"noteContainer":"Note_noteContainer__8vTRS","noteTitleContainer":"Note_noteTitleContainer__WIPot","noteInfo":"Note_noteInfo__K2Vjy"};